import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from "../../utils/axiosBaseQuery";

/* /admin/banks answers with the plain array, or with { message } when there are no
   banks. Writes answer 200 with a message even when nothing changed (e.g. unknown id),
   so only "Successfully …" counts as success — see bankMutationFailed. */
export const bankApi = createApi({
    reducerPath: 'bankApi',
    baseQuery: axiosBaseQuery({
        baseUrl: `${process.env.REACT_APP_BACKEND_HOST}/api/admin`,
    }),
    tagTypes: ['Banks'],
    endpoints: (build) => ({
        getBanks: build.query({
            query() {
                return {
                    url: `/banks`,
                    method: 'GET',
                }
            },
            transformResponse: (response) => (Array.isArray(response) ? response : []),
            providesTags: ['Banks']
        }),
        createBank: build.mutation({
            query({ name }) {
                return {
                    url: `/banks`,
                    method: 'POST',
                    data: { name },
                }
            },
            invalidatesTags: ['Banks']
        }),
        updateBank: build.mutation({
            query({ id, name }) {
                return {
                    url: `/banks/${id}`,
                    method: 'PUT',
                    data: { name },
                }
            },
            invalidatesTags: ['Banks']
        }),
        /* Soft delete: the bank disappears from the lists, citizens keep their bank_id */
        deleteBank: build.mutation({
            query({ id }) {
                return {
                    url: `/banks/${id}`,
                    method: 'PATCH',
                }
            },
            invalidatesTags: ['Banks']
        }),
    }),
});

export const bankMutationFailed = (result) =>
    !!result?.error || !/^Successfully/i.test(result?.data?.message || '');

export const {
    useGetBanksQuery,
    useLazyGetBanksQuery,
    useCreateBankMutation,
    useUpdateBankMutation,
    useDeleteBankMutation,
} = bankApi;
